import { render } from "./svg-vip.vue?vue&type=template&id=d2efb850"
import script from "./svg-vip.vue?vue&type=script&lang=ts"
export * from "./svg-vip.vue?vue&type=script&lang=ts"
script.render = render

export default script